import React from 'react';
import {
  Box,
  Typography,
  TablePagination,
  Paper
} from '@mui/material';

const PaginatedTable = ({ 
  children, 
  total, 
  page, 
  pageSize, 
  onPageChange, 
  onPageSizeChange,
  title,
  icon,
  loading = false
}) => {
  const startRecord = total === 0 ? 0 : (page * pageSize) + 1;
  const endRecord = Math.min((page + 1) * pageSize, total);

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Box display="flex" alignItems="center">
          {icon}
          <Typography variant="h4">
            {title}
          </Typography>
        </Box>
        {!loading && total > 0 && (
          <Typography variant="body2" color="text.secondary">
            Showing {startRecord}-{endRecord} of {total} records
          </Typography>
        )}
      </Box>
      
      {children}
      
      {!loading && total > pageSize && (
        <Box sx={{ mt: 2 }}>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(event, newPage) => onPageChange(newPage)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
            rowsPerPageOptions={[25, 50, 100, 200]}
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Paper>
  );
};

export default PaginatedTable; 